/**
 * Sprint G — Sentry frontend init.
 * Only initialize when REACT_APP_SENTRY_DSN is provided. Ignore silently
 * otherwise so preview builds don't send noise.
 */
import * as Sentry from "@sentry/react";

let initialized = false;

export function initSentryFrontend() {
    if (initialized) return;
    const dsn = process.env.REACT_APP_SENTRY_DSN;
    if (!dsn) return;
    try {
        Sentry.init({
            dsn,
            environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "preview",
            tracesSampleRate: 0.1,
            sendDefaultPii: false,
            beforeSend(event) {
                // Strip likely-PII fields
                try {
                    if (event.request?.headers) {
                        for (const k of Object.keys(event.request.headers)) {
                            if (["authorization", "cookie", "x-api-key"].includes(k.toLowerCase())) {
                                event.request.headers[k] = "[Filtered]";
                            }
                        }
                    }
                    if (event.user) {
                        delete event.user.email;
                        delete event.user.ip_address;
                    }
                    // Strip password/email/token fields from JSON bodies if present
                    const scrub = (obj) => {
                        if (!obj || typeof obj !== "object") return;
                        for (const k of Object.keys(obj)) {
                            const kl = k.toLowerCase();
                            if (["password", "token", "email", "work_email"].includes(kl)) {
                                obj[k] = "[Filtered]";
                            } else if (typeof obj[k] === "object") {
                                scrub(obj[k]);
                            }
                        }
                    };
                    scrub(event.extra);
                    scrub(event.contexts);
                } catch { /* best effort scrub */ }
                return event;
            },
        });
        initialized = true;
    } catch (e) {
        // Never let Sentry crash the app.
        // eslint-disable-next-line no-console
        console.warn("Sentry init failed:", e);
    }
}

export { Sentry };
